import { isMobile } from "../helpers/isMobile";
import { slotBarSymbolNames, slotSpineKey } from "../constants/symbolsNames"


const webSceneSpineResources = (gameName) => {
  return {
    1: {
      name: slotBarSymbolNames.icon1,
      path: `game/${gameName}/slotCharacters/web/symbol1/symbol1.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/symbol1/symbol1.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    2: {
      name: slotBarSymbolNames.icon2,
      path: `game/${gameName}/slotCharacters/web/symbol2/symbol2.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/symbol2/symbol2.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    3: {
      name: slotBarSymbolNames.icon3,
      path: `game/${gameName}/slotCharacters/web/symbol3/symbol3.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/symbol3/symbol3.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    4: {
      name: slotBarSymbolNames.icon4,
      path: `game/${gameName}/slotCharacters/web/symbol4/symbol4.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/symbol4/symbol4.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    5: {
      name: slotBarSymbolNames.icon5,
      path: `game/${gameName}/slotCharacters/web/symbol5/symbol5.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/symbol5/symbol5.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    6: {
      name: slotBarSymbolNames.icon6,
      path: `game/${gameName}/slotCharacters/web/symbol6/symbol6.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/symbol6/symbol6.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    7: {
      name: slotBarSymbolNames.icon7,
      path: `game/${gameName}/slotCharacters/web/symbol7/symbol7.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/symbol7/symbol7.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    8: {
      name: slotBarSymbolNames.icon8,
      path: `game/${gameName}/slotCharacters/web/scatter/scatter.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/scatter/scatter.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    400: {
      name: slotBarSymbolNames.icon12,
      path: `game/${gameName}/slotCharacters/web/jackpotSymbol/jackpotSymbol.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/web/jackpotSymbol/jackpotSymbol.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    gameLogo: {
      name: 'gameLogo',
      path: `game/${gameName}/logo/web/logo.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/logo/web/logo.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    winLine: {
      name: slotSpineKey.winLine,
      path: `game/${gameName}/line/web/line.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/line/web/line.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    winSymbolBorder: {
      name: slotSpineKey.winSymbolBorder,
      path: `game/${gameName}/winSymbolBorder/web/winFrame.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/winSymbolBorder/web/winFrame.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    boardFrame: {
      name: 'boardFrame',
      path: `game/${gameName}/boardFrame/web/boardFrame.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/boardFrame/web/boardFrame.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    winPopup: {
      name: 'winPopup',
      path: `frame/frameModuleResources/main/winPopup/web/PopUps.json`,
      config: {
        metadata: {
          spineAtlasFile: `frame/frameModuleResources/main/winPopup/web/PopUps.atlas`,
          imageNamePrefix: '_',
        },
      }
    },
    gambleAmountFrame: {
      name: 'gambleAmountFrame',
      path: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/web/amountFrame/amount.json',
      config: {
        metadata: {
          spineAtlasFile: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/web/amountFrame/amount.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    gambleCard: {
      name: 'gambleCard',
      path: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/web/card/card.json',
      config: {
        metadata: {
          spineAtlasFile: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/web/card/card.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    gambleSymbol: {
      name: 'gambleSymbol',
      path: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/web/symbol/symbol.json',
      config: {
        metadata: {
          spineAtlasFile: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/web/symbol/symbol.atlas',
          imageNamePrefix: '_',
        },
      },
    },
  }
};

const mobileSceneSpineResources = (gameName) => {
  return {
    1: {
      name: slotBarSymbolNames.icon1,
      path: `game/${gameName}/slotCharacters/mobile/symbol1/symbol1.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/symbol1/symbol1.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    2: {
      name: slotBarSymbolNames.icon2,
      path: `game/${gameName}/slotCharacters/mobile/symbol2/symbol2.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/symbol2/symbol2.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    3: {
      name: slotBarSymbolNames.icon3,
      path: `game/${gameName}/slotCharacters/mobile/symbol3/symbol3.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/symbol3/symbol3.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    4: {
      name: slotBarSymbolNames.icon4,
      path: `game/${gameName}/slotCharacters/mobile/symbol4/symbol4.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/symbol4/symbol4.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    5: {
      name: slotBarSymbolNames.icon5,
      path: `game/${gameName}/slotCharacters/mobile/symbol5/symbol5.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/symbol5/symbol5.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    6: {
      name: slotBarSymbolNames.icon6,
      path: `game/${gameName}/slotCharacters/mobile/symbol6/symbol6.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/symbol6/symbol6.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    7: {
      name: slotBarSymbolNames.icon7,
      path: `game/${gameName}/slotCharacters/mobile/symbol7/symbol7.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/symbol7/symbol7.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    8: {
      name: slotBarSymbolNames.icon8,
      path: `game/${gameName}/slotCharacters/mobile/scatter/scatter.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/scatter/scatter.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    400: {
      name: slotBarSymbolNames.icon12,
      path: `game/${gameName}/slotCharacters/mobile/jackpotSymbol/jackpotSymbol.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/slotCharacters/mobile/jackpotSymbol/jackpotSymbol.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    gameLogo: {
      name: 'gameLogo',
      path: `game/${gameName}/logo/mobile/logo.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/logo/mobile/logo.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    winLine: {
      name: slotSpineKey.winLine,
      path: `game/${gameName}/line/mobile/line.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/line/mobile/line.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    winSymbolBorder: {
      name: slotSpineKey.winSymbolBorder,
      path: `game/${gameName}/winSymbolBorder/mobile/winFrame.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/winSymbolBorder/mobile/winFrame.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    boardFrame: {
      name: 'boardFrame',
      path: `game/${gameName}/boardFrame/mobile/boardFrame.json`,
      config: {
        metadata: {
          spineAtlasFile: `game/${gameName}/boardFrame/mobile/boardFrame.atlas`,
          imageNamePrefix: '_',
        },
      },
    },
    winPopup: {
      name: 'winPopup',
      path: `frame/frameModuleResources/main/winPopup/mobile/PopUps.json`,
      config: {
        metadata: {
          spineAtlasFile: `frame/frameModuleResources/main/winPopup/mobile/PopUps.atlas`,
          imageNamePrefix: '_',
        },
      }
    },
    gambleAmountFrame: {
      name: 'gambleAmountFrame',
      path: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/mobile/amountFrame/amount.json',
      config: {
        metadata: {
          spineAtlasFile: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/mobile/amountFrame/amount.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    gambleCard: {
      name: 'gambleCard',
      path: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/mobile/card/card.json',
      config: {
        metadata: {
          spineAtlasFile: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/mobile/card/card.atlas',
          imageNamePrefix: '_',
        },
      },
    },
    gambleSymbol: {
      name: 'gambleSymbol',
      path: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/mobile/symbol/symbol.json',
      config: {
        metadata: {
          spineAtlasFile: 'frame/bettingControlModuleResources/bettingPartAssets/gambleFuture/mobile/symbol/symbol.atlas',
          imageNamePrefix: '_',
        },
      },
    },
  }
}
const webInfoSectionAtlases = (gameName) => {
  return {
    gameImages: {
      name: 'gameImages',
      path: `game/${gameName}/images/web/gameImages.json`,
      ktxPath: `game/${gameName}/images/web/gameImages.ktx2`,
      isTPSpriteAtlas: true
    },

    infoSection: {
      name: 'infoSection',
      path: `game/${gameName}/images/web/infoSection.json`,
      ktxPath: `game/${gameName}/images/web/infoSection.ktx2`,
      isTPSpriteAtlas: true
    }
  };
};

const mobileInfoSectionAtlases = (gameName) => {
  return {
    infoSection: {
      name: 'infoSection',
      path: `game/${gameName}/images/mobile/infoSection.json`,
      ktxPath: `game/${gameName}/images/mobile/infoSection.ktx2`,
      isTPSpriteAtlas: true
    },
    gameImages: {
      name: 'gameImages',
      path: `game/${gameName}/images/mobile/gameImages.json`,
      ktxPath: `game/${gameName}/images/mobile/gameImages.ktx2`,
      isTPSpriteAtlas: true
    }
  };
};

export const gameResources = (gameName) => {
  return [
    ...Object.values(isMobile() ? mobileInfoSectionAtlases(gameName) : webInfoSectionAtlases(gameName)),
    ...Object.values(isMobile() ? mobileSceneSpineResources(gameName) : webSceneSpineResources(gameName)),
  ]
}